// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1p9-W","inner":"Form_inner__5uxX2","range":"Form_range__2kh5-","name":"Form_name__EoVMY","actions":"Form_actions__2Ov9A"};